import axios from 'axios'

const baseResourceURL =
  window.location.host === 'adminknaufinsulation.mytravo.net'
    ? 'https://api.knaufinsulation.mytravo.net/'
    : 'https://api.knaufinsulationbeta.mytravo.net/'
const baseApiURL =
  window.location.host === 'adminknaufinsulation.mytravo.net'
    ? 'https://api.knaufinsulation.mytravo.net/api/v1/'
    : 'https://api.knaufinsulationbeta.mytravo.net/api/v1/'

// const baseResourceURL = "http://api.knaufinsulationbeta.mytravo.net/";
// const baseApiURL = "http://api.knaufinsulationbeta.mytravo.net/api/v1/";
const POST = 'POST'
const GET = 'GET'
const PUT = 'PUT'
const POST_FORM = 'POST-FORM'
const DELETE = 'DELETE'

const requestBuilder = (url, method, data, token) => {
  if (method === GET) {
    if (token) {
      return axios.get(url, {
        headers: { Authorization: 'Bearer ' + token },
      })
    } else {
      return axios.get(url)
    }
  } else if (method === POST) {
    if (token) {
      return axios.post(url, data, {
        headers: { Authorization: 'Bearer ' + token },
      })
    } else {
      return axios.post(url, data)
    }
  } else if (method === POST_FORM) {
    if (token) {
      return axios({
        method: 'post',
        url: url,
        data: data,
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'multipart/form-data',
        },
      })
    } else {
      return axios({
        method: 'post',
        url: url,
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    }
  } else if (method === DELETE) {
    if (token) {
      return axios({
        method: 'delete',
        url: url,
        data: data,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
    } else {
      return axios.delete(url, data)
    }
  } else if (method === PUT) {
    if (token) {
      return axios({
        method: 'put',
        url: url,
        data: data,
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
    } else {
      return axios.put(url, data)
    }
  } else {
    // We'll see if we need to handle more cases in the future.
  }
}

const login = (username, password) => {
  var form = new FormData()
  form.append('username', username)
  form.append('password', password)
  form.append('email', username)
  return requestBuilder(baseApiURL + 'login', POST_FORM, form, undefined)
}

const getToken = () => {
  var token = localStorage.getItem('USER_TOKEN')
  // if (!token) {
  //   return new Promise((resolve, reject) => {
  //     api.login("admin1@admin.com", "admin42").then(
  //       response => {
  //         var token = ((response || {}).data || {}).token;
  //         localStorage.setItem(USR_TKN, token);
  //         resolve(token);
  //       },
  //       rej => reject(rej)
  //     );
  //   });
  // }

  return new Promise((res, rej) => res(token))
}

const api = {
  resourceURL: baseResourceURL,
  apiURL: baseApiURL,
  getToken: getToken,
  login: login,
  getProduct: productId => {
    return new Promise((resolve, reject) => {
      getToken().then(token => {
        resolve(
          requestBuilder(
            baseApiURL + `products/${productId}`,
            GET,
            undefined,
            token,
          ),
        )
      })
    })
  },
  getProducts: () => {
    return new Promise((resolve, reject) => {
      getToken().then(token => {
        resolve(
          requestBuilder(baseApiURL + 'products?limit=0', GET, undefined, token),
        )
      })
    })
  },
  getProductsTypes: () => {
    return new Promise((resolve, reject) => {
      getToken().then(token => {
        resolve(
          requestBuilder(
            baseApiURL + 'productstype?limit=0',
            GET,
            undefined,
            token,
          ),
        )
      })
    })
  },

  getRelProductsProductIdx: RelProductsProductsIdx => {
    return new Promise((resolve, reject) => {
      getToken().then(token => {
        resolve(
          requestBuilder(
            baseApiURL + `relproductsproducts/${RelProductsProductsIdx}?limit=0`,
            GET,
            undefined,
            token,
          ),
        )
      })
    })
  },
  getRelProductsProducts: () => {
    return new Promise((resolve, reject) => {
      getToken().then(token => {
        resolve(
          requestBuilder(
            baseApiURL + 'relproductsproducts?limit=0',
            GET,
            undefined,
            token,
          ),
        )
      })
    })
  },
  deleteRelProduct: id => {
    return getToken().then(token => {
      return requestBuilder(
        baseApiURL + 'relproductsproducts' + '/' + id,
        DELETE,
        undefined,
        token,
      )
    })
  },
  getWorkstypes: () => {
    return new Promise((resolve, reject) => {
      getToken().then(token => {
        resolve(
          requestBuilder(
            baseApiURL + 'workstype?limit=0',
            GET,
            undefined,
            token,
          ),
        )
      })
    })
  },
  exportEmail: () => {
    return new Promise((res, rej) => {
      getToken().then(token => {
        res(
          requestBuilder(baseApiURL + 'email-export', POST, undefined, token),
        )
      })
    })
  },
  getClient: clientId => {
    return new Promise((resolve, reject) => {
      getToken().then(token => {
        resolve(
          requestBuilder(baseApiURL + `user/${clientId}`, GET, undefined, token),
        )
      })
    })
  },
  getClients: () => {
    return new Promise((res, rej) => {
      getToken().then(token => {
        res(requestBuilder(baseApiURL + 'user?limit=0', GET, undefined, token))
      })
    })
  },
  modifyClient: (userId, data) => {
    return new Promise((res, rej) => {
      getToken().then(token => {
        res(requestBuilder(baseApiURL + 'user/' + userId, POST, data, token))
      })
    })
  },
  addClient: user => {
    return new Promise((res, rej) => {
      getToken().then(token => {
        res(requestBuilder(baseApiURL + 'user/', POST, user, token))
      })
    })
  },
  deleteClient: userId => {
    return new Promise((res, rej) => {
      getToken().then(token => {
        res(
          requestBuilder(
            baseApiURL + 'user/' + userId,
            DELETE,
            undefined,
            token,
          ),
        )
      })
    })
  },
  addProduct: product => {
    return new Promise((res, rej) => {
      getToken().then(token => {
        res(requestBuilder(baseApiURL + 'products/', POST, product, token))
      })
    })
  },

  addRelProductsProducts: product => {
    const form = new FormData()

    form.append('products_id_master', product.products_id_master)
    form.append('products_id_remote', product.products_id_remote)
    form.append('worktype', product.worktype)

    return new Promise((res, rej) => {
      getToken().then(token => {
        res(
          requestBuilder(
            baseApiURL + 'relproductsproducts',
            POST_FORM,
            form,
            token,
          ),
        )
      })
    })
  },

  updateRelProductsProducts: product => {
    return getToken().then(token => requestBuilder(
      requestBuilder(
        baseApiURL + 'relproductsproducts/' + product.id,
        POST,
        product,
        token,
      ),
    ))
  },

  modifyProduct: (productId, data) => {
    return new Promise((res, rej) => {
      getToken().then(token => {
        res(
          requestBuilder(
            baseApiURL + 'products/' + productId,
            POST,
            data,
            token,
          ),
        )
      })
    })
  },
  deleteProduct: productId => {
    return new Promise((res, rej) => {
      getToken().then(token => {
        res(
          requestBuilder(
            baseApiURL + 'products/' + productId,
            DELETE,
            undefined,
            token,
          ),
        )
      })
    })
  },

  getPreselectForProduct: productId => {
    return getToken()
      .then(token => requestBuilder(
        baseApiURL + `preselect?limit=0&attr=product_id&value=${productId}`,
        GET,
        undefined,
        token,
      ))
  },

  createPreselectForProduct: (productId, preselect) => {
    const form = new FormData()

    form.append('solution_id', preselect.solution_id)
    form.append('monobicouche', preselect.monobicouche)
    form.append('entreousouschevron', preselect.entreousouschevron)
    form.append('height', preselect.height)
    form.append('r', preselect.r)
    form.append('product_id', productId)
    form.append('type_id', '5')

    return new Promise((res, rej) => {
      getToken().then(token => {
        res(
          requestBuilder(
            baseApiURL + 'preselect',
            POST_FORM,
            form,
            token,
          ),
        )
      })
    })
  },

  deletePreselectForProduct: preselectId => {
    return getToken().then(token => requestBuilder(
      baseApiURL + 'preselect/' + preselectId,
      DELETE,
      undefined,
      token,
    ))
  },

  modifyPreselectForProduct: (preselectId, data) => {
    return getToken().then(token =>
      requestBuilder(
        baseApiURL + 'preselect/' + preselectId,
        POST,
        data,
        token,
      ))
  },
}

export default api



// WEBPACK FOOTER //
// ./src/services/Api.js